<template>
    <div>
        <v-row>
            <v-col cols="12" md="8">
                <v-card outlined>
                    <v-card-title class="d-flex justify-center primary--text text-subtitle-2">
                        Listado de actividades
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12">
                                <AutocompleteComp v-model="areaActividad" :items="ActividadesAlumn" text-label="Áreas"
                                    item-text="area" @change="changeListAct" return-object style="max-width: 200px;" />
                            </v-col>
                            <v-col>
                                <ComundataTablecomp :headers="headerActividadesMeticas" :items="tableActividad">
                                    <template v-slot:desc_curso="{ item }">
                                        <v-chip :color="item.color_curso" dark small>
                                            <v-icon small left>
                                                {{ item.icono_curso }}
                                            </v-icon>
                                            {{ item.desc_curso }}
                                        </v-chip>
                                    </template>
                                </ComundataTablecomp>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="4" class="d-flex align-center justify-center">
                <v-card outlined>
                    <v-card-title class="d-flex justify-center primary--text text-subtitle-2">
                        Porcentaje por notas
                    </v-card-title>
                    <v-card-text class="d-flex justify-center">
                        <div id="chart">
                            <apexchart type="pie" width="400" :options="chartOptions" :series="series"></apexchart>
                        </div>
                    </v-card-text>
                    <v-card-subtitle class="d-flex text-center">
                        <span>
                            El siguiente gráfico refleja el compromiso del estudiante con las actividades asignadas por el docente y el porcentaje de las calificaciones obtenidas
                        </span>
                    </v-card-subtitle>
                </v-card>

            </v-col>
        </v-row>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import axios from "@/helpers/axios";
import { headerActividadesMeticas } from '../../../../helpers/headersTable';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
export default {
    props: ['filter'],
    components: {
        apexchart: VueApexCharts,
        ComundataTablecomp,
        AutocompleteComp
    },
    data: () => ({
        headerActividadesMeticas,
        ActividadesAlumn: [],
        areaActividad: [],
        tableActividad: [],
        porcentajeActividades: "",

        series: [],
        chartOptions: {
            chart: {
                width: 380,
                type: 'pie',
            },
            legend: {
                position: 'right',
                offsetY: 50,

            },
            labels: ['Nota AD', 'Nota A', 'Nota B', 'Nota C', 'No presentada'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },

                }
            }]
        },
    }),
    methods: {

        async changeListAct() {
            this.tableActividad = this.areaActividad.actividades
            let calificacionesNulas = 0;
            let calificacionesNoNulas = 0;
            let contadorAD = 0;
            let contadorA = 0;
            let contadorB = 0;
            let contadorC = 0;
            let contadorNull = 0;

            this.tableActividad.forEach(actividad => {
                if (actividad.calificacion_revision === 'A') {
                    contadorA++;
                } else if (actividad.calificacion_revision === 'AD') {
                    contadorAD++;
                } else if (actividad.calificacion_revision === null) {
                    contadorNull++;
                } else if (actividad.calificacion_revision === 'B') {
                    contadorB++;
                } else if (actividad.calificacion_revision === 'C') {
                    contadorC++;
                }
            }),

                this.tableActividad.forEach(actividad => {
                    if (actividad.calificacion_revision === null) {
                        calificacionesNulas++;
                    } else {
                        calificacionesNoNulas++;
                    }
                });

            let total = calificacionesNoNulas + calificacionesNulas;
            this.porcentajeActividades = (calificacionesNoNulas / total) * 100;
            this.series = [contadorAD, contadorA, contadorB, contadorC, contadorNull]

        },

        async getActividadesAlumn() {
            this.ActividadesAlumn = [];
            this.series = [];
            try {
                const response = await axios.post("/metricaActividades/", { id_alumno: this.filter.id_alumno })
                this.ActividadesAlumn = response.data
                const actividadesPorArea = {};
                response.data.forEach(actividad => {
                    const area = actividad.desc_area;
                    if (!actividadesPorArea[area]) {
                        actividadesPorArea[area] = [];
                    }
                    actividadesPorArea[area].push(actividad);
                });

                this.ActividadesAlumn = Object.keys(actividadesPorArea).map(area => ({
                    area,
                    actividades: actividadesPorArea[area]
                }));




            } catch (error) {
                console.error(error);
            }
        },
    },
    mounted() {
        this.getActividadesAlumn();
    },
}



</script>